module.exports = __webpack_public_path__ + "img/Gallery_3_03.b394309c.jpeg";